import React from 'react';

const ContenidoAvisoPrivacidad = () => (
  <main className="container py-6 py-md-8">
    <article className="mx-auto" style={{ maxWidth: 960 }}>
      <p className="mb-4">
        Decototal · decototal.com.mx · Última actualización: 9 de octubre de 2026
      </p>

      <h2 className="h3">Respetamos tu privacidad</h2>
      <p>
        En cumplimiento a la Ley Federal de Protección de Datos Personales en Posesión de los
        Particulares, Decototal pone a disposición del público en general su aviso de privacidad,
        con las políticas de confidencialidad y tratamiento de los datos personales que se recaban
        a través de este sitio web.
      </p>

      <h2 className="h3 mt-4">I. Identidad y domicilio del responsable</h2>
      <p>
        Decototal (en adelante, "Decototal") es una empresa mexicana dedicada a la comercialización
        y distribución de recubrimientos decorativos sintéticos para pisos y muros, y es responsable
        del tratamiento de los datos personales que usted proporcione a través del sitio web
        decototal.com.mx.
      </p>
      <p>
        Para cualquier asunto relacionado con este aviso, Decototal señala como domicilio sus
        instalaciones ubicadas en Pte. 118 No. 333-A, Col. Capultitlán, C.P. 07370, Alcaldía Gustavo
        A. Madero, Ciudad de México; teléfono <a href="tel:+525596273546">55 96 27 35 46</a>.
      </p>

      <h2 className="h3 mt-4">II. Datos que se recabarán y vías para su obtención</h2>
      <p>
        Atendiendo a los principios de licitud, consentimiento, información, calidad, finalidad,
        lealtad, proporcionalidad y responsabilidad, Decototal puede recabar sus datos personales
        por los siguientes medios: (1) cuando usted los proporciona a través de los formularios del
        sitio web, como el formulario de contacto o el de cotización de material; (2) cuando usted
        nos contacta por WhatsApp o teléfono; y (3) de forma automática, cuando
        usted navega por el sitio.
      </p>
      <p>
        <strong>Datos de contacto y de interés.</strong> A través de los formularios se solicitan
        datos como nombre, número de teléfono, correo electrónico y la información relacionada con
        los productos de su interés (por ejemplo, el tipo de producto o la cantidad de material que
        requiere cotizar), así como los comentarios que usted decida enviarnos.
      </p>
      <p>
        <strong>Datos de navegación.</strong> Al ingresar al sitio se recaba información como la
        dirección IP, el tipo de navegador y dispositivo, las páginas visitadas, la duración de la
        visita, las secciones con las que interactúa y la fuente desde la que llegó al sitio. Esta
        información se obtiene mediante herramientas de analítica y publicidad como HubSpot, Google
        Analytics 4 y Google Ads, que pueden utilizar cookies y tecnologías similares, con el fin de
        obtener estadísticas sobre el comportamiento de los visitantes, el desempeño del sitio y de
        nuestras campañas.
      </p>
      <p>
        <strong>Datos sensibles.</strong> Decototal no solicita datos personales sensibles a través
        del sitio web. Si usted decide avanzar a la etapa de compra, podrán requerirse datos
        adicionales necesarios para formalizar la venta, como datos de entrega y de facturación, los
        cuales se tratarán únicamente para ese fin.
      </p>

      <h2 className="h3 mt-4">III. Finalidades del tratamiento de los datos personales</h2>
      <p>
        Sus datos personales serán tratados para las siguientes finalidades, todas necesarias para
        la relación que usted solicita con Decototal:
      </p>
      <ol>
        <li>Responder sus solicitudes de cotización y enviarle la información que requiera sobre nuestros productos.</li>
        <li>Dar seguimiento a su solicitud y mantener comunicación con usted para resolver sus dudas sobre los productos.</li>
        <li>Administrar y organizar la información de las personas que solicitan una cotización o información, mediante la plataforma de gestión de clientes HubSpot.</li>
        <li>En caso de que se concrete una compra, formalizar la venta, coordinar la entrega y emitir los comprobantes fiscales correspondientes.</li>
        <li>Elaborar estadísticas y analizar el rendimiento del sitio web y de nuestras campañas, a través de plataformas como HubSpot, Google Analytics 4 y Google Ads.</li>
      </ol>
      <p>Sus datos personales no se utilizan para el envío de promociones ni de boletines informativos.</p>

      <h2 className="h3 mt-4">IV. Opciones y medios para limitar el uso o divulgación de los datos personales</h2>
      <p>
        Usted, como titular de los datos personales, podrá limitar su uso y divulgación manifestando
        su oposición mediante un escrito en formato libre dirigido a Decototal, en el domicilio
        señalado en el apartado I de este aviso.
      </p>

      <h2 className="h3 mt-4">V. Medios para ejercer los derechos de acceso, rectificación, cancelación u oposición (ARCO)</h2>
      <p>A manera de referencia, estos son los derechos que usted puede ejercer:</p>
      <ul>
        <li><strong>Acceso:</strong> solicitar que se le informe qué datos personales trata Decototal, su origen y las comunicaciones que se hayan realizado con ellos.</li>
        <li><strong>Rectificación:</strong> solicitar que se corrijan o complementen los datos que sean incorrectos o estén incompletos.</li>
        <li><strong>Cancelación:</strong> cuando sus datos dejen de ser necesarios para las finalidades para las que fueron recabados, solicitar que sean cancelados. La cancelación irá precedida de un periodo de bloqueo, equivalente al plazo de prescripción de las acciones que dieron origen al tratamiento o al que establezca la ley.</li>
        <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos cuando exista una causa legítima para ello, aun habiendo otorgado antes su consentimiento.</li>
      </ul>
      <p>
        Usted o su representante legal debidamente acreditado podrá ejercer estos derechos en
        cualquier momento, mediante un escrito en formato libre dirigido a Decototal en el
        domicilio señalado en el apartado I. El escrito deberá contener:
      </p>
      <ol>
        <li>Nombre del titular de los datos personales o de su representante legal.</li>
        <li>Domicilio o medio electrónico para notificarle la respuesta a su solicitud.</li>
        <li>Descripción clara y precisa de los datos personales respecto de los que desea ejercer alguno de los derechos mencionados.</li>
        <li>En solicitudes de rectificación, el dato que es erróneo y la corrección que debe realizarse.</li>
        <li>Los datos, documentos o registros que faciliten la localización de los datos personales.</li>
      </ol>
      <p>
        Asimismo, deberá adjuntar los documentos que acrediten su identidad o, en su caso, la
        representación legal, así como los que sustenten su petición.
      </p>
      <p>
        Decototal comunicará la determinación adoptada en un plazo no mayor a veinte días hábiles
        contados a partir de la fecha en que se reciba la solicitud, y si resulta procedente, se
        hará efectiva dentro de los quince días hábiles siguientes a la respuesta. Tratándose de
        solicitudes de acceso, se dará por cumplida cuando los datos se pongan a disposición del
        titular o mediante la expedición de copias simples, documentos electrónicos o cualquier
        otro medio que Decototal determine.
      </p>
      <p>Decototal podrá negar el acceso, la rectificación, la cancelación o la oposición en los siguientes supuestos:</p>
      <ol>
        <li>Cuando el solicitante no sea el titular de los datos o su representante legal no esté debidamente acreditado.</li>
        <li>Cuando en su base de datos no se encuentren los datos personales del solicitante.</li>
        <li>Cuando se lesionen los derechos de un tercero.</li>
        <li>Cuando exista un impedimento legal o una resolución de autoridad competente que restrinja el acceso o no permita la rectificación, cancelación u oposición.</li>
        <li>Cuando la rectificación, cancelación u oposición haya sido previamente realizada.</li>
      </ol>
      <p>
        Decototal no estará obligada a cancelar los datos personales cuando se refieran a las partes
        de un contrato y sean necesarios para su desarrollo y cumplimiento, deban ser tratados por
        disposición legal, obstaculicen actuaciones judiciales o administrativas vinculadas a
        obligaciones fiscales, o sean necesarios para cumplir una obligación legalmente adquirida
        por el titular.
      </p>

      <h2 className="h3 mt-4">VI. Transferencia y remisión de datos</h2>
      <p>
        Decototal no transfiere sus datos personales a terceros para fines de promoción o
        mercadotecnia. Para las finalidades descritas en este aviso, sus datos pueden ser tratados
        por proveedores tecnológicos que actúan por cuenta de Decototal, como HubSpot
        (administración de clientes y prospectos), Google (analítica y publicidad) y los proveedores
        de alojamiento del sitio web, los cuales pueden encontrarse en territorio nacional o en el
        extranjero. Decototal procurará que dichos proveedores cuenten con medidas de seguridad
        adecuadas y que no utilicen su información para fines distintos a los establecidos en este
        aviso.
      </p>
      <p>Además, sus datos podrán ser comunicados a las autoridades competentes cuando exista un requerimiento conforme a la ley.</p>

      <h2 className="h3 mt-4">VII. Revocación del consentimiento</h2>
      <p>
        Usted podrá revocar en cualquier momento el consentimiento otorgado para el tratamiento de
        sus datos personales, presentando una solicitud por escrito dirigida a Decototal en el
        domicilio señalado en el apartado I, indicando su deseo de revocar el consentimiento.
        Decototal podrá negar la revocación en los casos en que la ley lo permita, por ejemplo
        cuando los datos sean necesarios para cumplir una obligación legal o contractual.
      </p>

      <h2 className="h3 mt-4">VIII. Medidas de seguridad</h2>
      <p>
        Para la protección de sus datos personales, Decototal ha implementado medidas de seguridad
        administrativas, técnicas y físicas que buscan garantizar su confidencialidad, integridad y
        disponibilidad, con el objeto de evitar pérdida, uso indebido o alteración de la información.
        Cuando por la naturaleza de nuestros servicios debamos compartir información con terceros
        que nos prestan algún servicio, requerimos que cuenten con medidas de seguridad adecuadas
        para proteger sus datos personales.
      </p>

      <h2 className="h3 mt-4">IX. Cambios al aviso de privacidad</h2>
      <p>
        Si se producen cambios a este aviso de privacidad, Decototal los dará a conocer mediante su
        publicación en el sitio web decototal.com.mx o a través del correo electrónico que usted
        haya proporcionado.
      </p>

      <h2 className="h3 mt-4">X. Autoridad en materia de protección de datos</h2>
      <p>
        Si considera que su derecho a la protección de datos personales ha sido vulnerado, puede
        acudir ante la autoridad competente en la materia, actualmente la Secretaría Anticorrupción
        y Buen Gobierno.
      </p>
      <p className="mt-4">Ciudad de México, a 9 de octubre de 2026 (última actualización).</p>
    </article>
  </main>
);

export default ContenidoAvisoPrivacidad;
